import React from "react";
import { Form, Row, Col, Divider, Typography, Select, message } from "antd";
import { c_TipoDeRelación } from "../../../SATCatalogos/index";
import SelectFactura from "../../Inputs/SelectFactura";
import { getFactura, getConceptosFromFacturas } from "../services";

const { Title, Text } = Typography;
const { Option } = Select;

const RelacionFacturasSection = (props) => {

    const [ FacturasList, setFacturasList ] = React.useState([]) //Lista donde se almacenan las facturas para relacionar

    const { clienteId } = props
    const form = Form.useFormInstance()

    const onSelectFactura = async (factura_id) => {
        try {
            let factura = await getFactura(factura_id);
            if(!factura) throw new Error("No se pudo obtener la factura seleccionada");

            let data = getConceptosFromFacturas(factura, FacturasList);

            setFacturasList((prev) => [...prev, factura]);
            
            if (form) {
                form.setFieldsValue({
                    Conceptos: data.conceptos_facturas,
                    SubTotal: data.monto,
                    Total: data.total,
                    Impuestos: {
                        TotalImpuestosTrasladados: data.imp_trasladados
                    }
                });
            }
            
        } catch (error) {
            console.error("Error al obtener la factura relacionada:", error);
            message.error("Error al obtener la factura relacionada. Por favor, intente nuevamente.");
        }
    }

    const onDeselectFactura = (factura_id) => {
        setFacturasList((prev) => prev.filter(f => f._id !== factura_id))
        let data = getConceptosFromFacturas(null, FacturasList.filter(f => f._id !== factura_id))
        if (form) {
            form.setFieldsValue({
                Conceptos: data.conceptos_facturas,
                SubTotal: data.monto,
                Total: data.total,
                Impuestos: {
                    TotalImpuestosTrasladados: data.imp_trasladados
                }
            });
        }
    }

    const handleSelect = (factura_id) => {
        const current = form.getFieldValue("facturas_ids") ?? []
        if (!current.includes(factura_id))
            form.setFieldValue("facturas_ids", [...current, factura_id])
        onSelectFactura(factura_id)
    }

    const handleDeselect = (factura_id) => {
        const current = form.getFieldValue("facturas_ids") ?? []
        form.setFieldValue("facturas_ids", current.filter(id => id !== factura_id))
        onDeselectFactura(factura_id)
    }

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Información de Relación a Facturas</Title>
            </Row>
            <Form.Item name="facturas_ids" hidden initialValue={[]} />
            <Row className="mb-1" gutter={[16, 16]}>
                <Col xs={20} md={8}>
                    <Form.Item
                        name={["CfdiRelacionados", "UUID"]}
                        label="Factura a relacionar"
                        rules={[
                            {
                                required: false,
                                message: "Seleccione la factura a relacionar",
                            },
                        ]}
                    >
                        <SelectFactura
                            params={{cliente_id: props.clienteId}}
                            placeholder="Seleccione la factura a relacionar"
                            onSelect={handleSelect}
                            onDeselect={handleDeselect}
                            allowClear={false}
                        />
                    </Form.Item>
                </Col>
                <Col xs={20} md={8}>
                    <Form.Item
                        name={["CfdiRelacionados", "TipoRelacion"]}
                        label="Tipo de Relación"
                        rules={[
                            {
                                required: true,
                                message: "Seleccione el tipo de relación",
                            },
                        ]}
                    >
                        <Select placeholder="Seleccione el tipo de relación" filterOption={false}>
                            {c_TipoDeRelación.map(({ tipo_relacion, descripción }) => (
                                <Option key={tipo_relacion} value={tipo_relacion}>
                                    <strong>{tipo_relacion}</strong> -{" "}
                                    <Text style={{ wordWrap: "break-word" }}>{descripción}</Text>
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default RelacionFacturasSection;
